// extracted by mini-css-extract-plugin
export default {"carusel":"carusel___nKKRP","slides":"slides___k6i4Z","panel":"panel___o0RMR","controls":"controls___XKWlm","prev":"prev___n7u8e","next":"next___WJJcC","list":"list___NE1zD"};